import type { IconDef } from '../types';

export const hamburgerMenu: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M22.9092 18C23.5091 18 24 18.4909 24 19.0908C24 19.6798 23.542 20.1596 22.9531 20.1816H1.09082C0.490861 20.1816 0 19.6908 0 19.0908C4.84371e-05 18.4909 0.49089 18.011 1.09082 18H22.9092ZM22.9092 11C23.5091 11 24 11.4909 24 12.0908C24 12.6798 23.542 13.1596 22.9531 13.1816H1.09082C0.490861 13.1816 0 12.6908 0 12.0908C4.84371e-05 11.4909 0.49089 11.011 1.09082 11H22.9092ZM22.9092 3C23.5091 3.00005 24 3.49089 24 4.09082C24 4.67978 23.542 5.15962 22.9531 5.18164H1.09082C0.490861 5.18159 0 4.69079 0 4.09082C4.8437e-05 3.49089 0.49089 3.00005 1.09082 3H22.9092Z',
    },
  ],
};
